package com.zaurh.mapquizwebsite.presentation.screen.home

import com.zaurh.mapquizwebsite.domain.model.UserDataDO
import com.zaurh.mapquizwebsite.utils.EMPTY

data class MainUIState(
    val isLoading: Boolean = false,
    val isSignInAlertVisible: Boolean = false,
    val signInUsername: String = EMPTY,
    val userData: UserDataDO? = null
)

sealed interface MainAction {
    data object OnInit: MainAction
    data object OnSignInClicked: MainAction
    data class OnSignInUsernameChange(val value: String): MainAction
    data object OnSignInAlertDismissed: MainAction
    data object OnSignInAlertConfirmed: MainAction
    data object OnLogOutClicked: MainAction
    data object OnHomeClicked: MainAction
    data object OnDailyRewardsClicked: MainAction
}

sealed interface MainSideEffect {
    data object NavigateToHome: MainSideEffect
    data object NavigateToDailyRewards: MainSideEffect
}